import { useFormState } from 'informed';
import type React from 'react';
import type { FC, PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import type { ValidatorMessage } from '@/helpers/validators';
import type { RegistrationConfig } from '@/modules/registration/helpers/types';
import { InputStructure } from '../structures/InputStructure';
import { getErrorTranslation } from '../utils';

import { ScFormGroup, type ScFormGroupProps } from './styled';

interface FormGroupProps extends ScFormGroupProps {
  title?: string;
  error?: React.ReactNode;
  addons?: React.ReactElement;
  tooltip?: React.ReactElement;
  field?: string;
  showErrorMessage?: boolean;
  styleScheme?: RegistrationConfig['styleScheme'];
}

export const FormGroup: FC<PropsWithChildren<FormGroupProps>> = ({
  children,
  title,
  error,
  tooltip,
  addons,
  marginTop,
  field,
  showErrorMessage,
  ...rest
}) => {
  const { t } = useTranslation();

  const { errors } = useFormState();

  return (
    <ScFormGroup marginTop={marginTop} {...rest}>
      <>
        {title && <h3>{title}</h3>}
        {tooltip && <div className="tooltip">{tooltip}</div>}
        <InputStructure error={error}>{children}</InputStructure>
        {addons && <div className="addons">{addons}</div>}
        {showErrorMessage && field && errors[field] && (
          <div className="error">
            {getErrorTranslation(t, errors[field] as ValidatorMessage)}
          </div>
        )}
      </>
    </ScFormGroup>
  );
};
